module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-responsive"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key.value
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key.value)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("capitalize")(key.label)) + "\n          "), (!_vm.isObj(key.value)) ? _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key.value] > 0 ? 'asc' : 'dsc'
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.actionCol) ? _c('th', {
    staticClass: "action"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_grid_col_action')))]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredData), function(entry, entryIndex) {
    return _c('tr', [_vm._l((_vm.columns), function(key, index) {
      return _c('td', [((!_vm.editable || !_vm.editable[index]) && _vm.copyButtons.indexOf(key.value) < 0) ? _c('span', [_vm._v("\n                " + _vm._s(entry[key.value]) + "\n            ")]) : _vm._e(), _vm._v(" "), (entry.locked && key.value === 'locked') ? _c('button', {
        staticClass: "btn btn-default",
        attrs: {
          "title": _vm.getTranslation('lbl_unlock')
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.unlock(entry)
          }
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-lock",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e(), _vm._v(" "), ((!_vm.editable || !_vm.editable[index]) &&
        _vm.copyButtons.indexOf(key.value) >= 0 && entry[key.value]) ? _c('button', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (entry[key.value]),
          expression: "entry[key.value]",
          arg: "copy"
        }],
        staticClass: "btn btn-default",
        on: {
          "click": function($event) {
            $event.preventDefault();
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('lbl_copy')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.editable && _vm.editable[index]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry[key.value]),
          expression: "entry[key.value]"
        }],
        ref: "'entry'+index",
        refInFor: true,
        staticClass: "form-control",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (entry[key.value])
        },
        on: {
          "keyup": [function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
            _vm.update(entry);
            _vm.moveNext($event)
          }, function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
            _vm.cancel(entry)
          }],
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(entry, key.value, $event.target.value)
          }
        }
      }) : _vm._e()])
    }), _vm._v(" "), (_vm.actionCol) ? _c('td', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [(_vm.viewBtn) ? _c('router-link', {
      staticClass: "btn btn-default",
      attrs: {
        "to": _vm.viewLink + '/' + entry[_vm.idField],
        "tag": "button",
        "title": _vm.getTranslation('lbl_view')
      }
    }, [_c('span', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.editBtn && !entry.noEdit) ? _c('router-link', {
      staticClass: "btn btn-default",
      attrs: {
        "to": _vm.actionLink + '/' + entry[_vm.idField],
        "title": _vm.getTranslation('lbl_edit')
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.saveBtn) ? _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "title": _vm.getTranslation('lbl_check')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(entry)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-ok",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.cancelBtn) ? _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "title": _vm.getTranslation('lbl_refresh')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.cancel(entry)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-refresh",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.deleteBtn && !entry.noDelete) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteEntry(entry)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash",
      attrs: {
        "title": _vm.getTranslation('lbl_delete'),
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.history && !entry.noHistory) ? _c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": _vm.history + '/' + entry[_vm.idField],
        "tag": "button",
        "title": _vm.getTranslation('lbl_history')
      }
    }, [_c('i', {
      staticClass: "fa fa-history",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1) : _vm._e()], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-291730e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Banet/components/BanetTablegrid.vue
// module id = 672
// module chunks = 0